import { useState } from 'react';
import useCallbackRef from '../useCallbackRef';
/**
 * Returns a pair of boolean state value and a toggle function, which flips the state.
 * Toggle function has 'on' and 'off' properties, which set state directly to true or false.
 * @param initialValue - boolean value to initialize the state
 */
export default function useToggle(initialValue) {
    const [value, setValue] = useState(!!initialValue);
    const on = useCallbackRef(() => setValue(true));
    const off = useCallbackRef(() => setValue(false));
    const toggle = useCallbackRef(() => setValue(x => !x));
    toggle.on = on;
    toggle.off = off;
    return [value, toggle];
}
